<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName="Rebate calculations Rule List"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>